<script setup>
import Breadcrumb from 'dashboard/components-next/breadcrumb/Breadcrumb.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

defineProps({
  icon: { type: String, required: true },
  title: { type: String, required: true },
  description: { type: String, default: '' },
  breadcrumbs: { type: Array, default: () => [] },
});

const emit = defineEmits(['breadcrumbClick']);
</script>

<template>
  <header
    class="w-full rounded-2xl border border-n-weak bg-n-solid-2 p-5 sm:p-6"
  >
    <Breadcrumb
      v-if="breadcrumbs.length"
      :items="breadcrumbs"
      class="mb-3"
      @click="item => emit('breadcrumbClick', item)"
    />
    <div class="flex flex-wrap items-start justify-between gap-4">
      <div class="flex min-w-0 grow basis-72 items-start gap-3">
        <span
          class="grid size-11 shrink-0 place-items-center rounded-xl bg-n-brand/10 text-n-brand"
          aria-hidden="true"
        >
          <Icon :icon="icon" class="size-6" />
        </span>
        <div class="min-w-0">
          <h1 class="mb-1 break-words text-xl font-semibold text-n-slate-12">
            {{ title }}
          </h1>
          <p
            v-if="description"
            class="mb-0 max-w-3xl text-sm leading-relaxed text-n-slate-11"
          >
            {{ description }}
          </p>
        </div>
      </div>
      <div v-if="$slots.actions" class="flex shrink-0 flex-wrap gap-2">
        <slot name="actions" />
      </div>
    </div>
    <div
      v-if="$slots.default"
      class="mt-5 flex flex-wrap items-center justify-between gap-3 border-t border-n-weak pt-4"
    >
      <slot />
    </div>
  </header>
</template>
